import React from 'react';
import { Form } from '../../../types/schema';
import { AnswerBackend, AnswerState } from '../types';
import { initializeAnswers } from '../utils';

export const useFormAnswers = (form: Form) => {
  const [answers, setAnswers] = React.useState<AnswerState>(() => initializeAnswers(form));

  const handleAnswerChange = React.useCallback(({ question, answer }: AnswerBackend) => {
    setAnswers((prev) => ({
      ...prev,
      [question]: {
        ...prev[question],
        answer,
        error: answer ? null : prev[question].error,
      },
    }));
  }, []);

  const setAnswerError = React.useCallback((question: string, error: string | null) => {
    setAnswers((prev) => ({
      ...prev,
      [question]: {
        ...prev[question],
        error,
      },
    }));
  }, []);

  const clearAllErrors = React.useCallback(() => {
    setAnswers((prev) => {
      const updated = { ...prev };
      Object.keys(updated).forEach((question) => {
        updated[question] = {
          ...updated[question],
          error: null,
        };
      });
      return updated;
    });
  }, []);

  const addPromptAnswers = React.useCallback((promptAnswers: AnswerState) => {
    setAnswers((prev) => ({
      ...prev,
      ...promptAnswers,
    }));
  }, []);

  return {
    answers,
    setAnswers,
    handleAnswerChange,
    setAnswerError,
    clearAllErrors,
    addPromptAnswers,
  };
};
